import React from 'react';
import '../styles/ContactPage.css';

const ContactPage = () => {
  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="container">
          <h1>İletişim</h1>
          <p className="contact-description">
            Projeleriniz ve sorularınız için bizimle iletişime geçebilirsiniz.
            En kısa sürede size dönüş yapacağız.
          </p>
        </div>
      </section>

      <section className="contact-info">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-details">

              <div className="contact-item">
                <h3>Adres</h3>
                <p>Taksim360</p>
                <p>Çukur, Tarlabaşı Blv No: 122, 34435</p>
                <p>Beyoğlu/İstanbul</p>
              </div>

              <div className="contact-item">
                <h3>Telefon</h3>
                <p>+90 (555) 685 75 45</p>
              </div>

              <div className="contact-item">
                <h3>E-posta</h3>
                <p>info@5n1pr.com.tr</p>
              </div>
            </div>

            <div className="contact-map">
              <div className="map-container">
                <iframe
                  title="5N1PR Ofis Konumu"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4821.624689326753!2d28.97894518714727!3d41.0363947962924!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab667657954d1%3A0x44e1aaaa6b1a6603!2zNU4xUFIgxLBsZXRpxZ9pbSBEYW7EscWfbWFubMSxxJ_EsQ!5e0!3m2!1str!2str!4v1747837751746!5m2!1str!2str"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
